<template>
  <scroll-center-dialog
      v-model="dialog_flag"
      @close="closeDialog"
      title="Опрос"
      :applyable="false"
  >
    <template>
      <SurveyingDetailTemplate :survey="dialog_data"></SurveyingDetailTemplate>
      <v-sheet>
        <v-alert type="error" v-for="(error, index) in getNonFieldErrors()" rounded="0" dismissible @input="deleteNonFieldError(error)" :key="`error_${index}`">
          {{error[0]}}
        </v-alert>
      </v-sheet>
    </template>
    <v-card-text  v-if="!available">
      <v-alert outlined type="info" class="text-h6">
        Данный опрос недоступен
      </v-alert>
    </v-card-text>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <EmailCheckAttempt
        :survey-data="dialog_data"
        :attempt-status="attempt_status"
        @continue="continueView"
      ></EmailCheckAttempt>
      <span  v-if="available">
        <v-btn
          v-if="attempt_status === false"
          color="success"
          depressed
          @click="openSurveying"
          :loading="loading"
        >
        Начать опрос
      </v-btn>
      <v-btn
          v-if="attempt_status && attempt_ended === false"
          color="success"
          depressed
          @click="continueSurveying"
          :loading="loading"
      >
        Продолжить опрос
      </v-btn>
      </span>

      <span
          v-if="attempt_status && attempt_ended === true"
          style="font-size: 20px; margin-top: -20px; padding-bottom: 10px"
      >
        Опрос пройден
      </span>
      <v-spacer></v-spacer>
    </template>
  </scroll-center-dialog>
</template>

<script>
import names from "../routers/names";
import {mapActions, mapGetters} from "vuex"
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import {displayDate, urlify} from "@/helper";
import EmailCheckAttempt from "@/modules/survey/surveys/EmailCheckAttempt.vue";
import SurveyingDetailTemplate from "@/modules/survey/surveys/SurveyingDetailTemplate.vue";

export default {
  name: "BeforeSurvey",
  mixins: [FormErrorsMixin],
  components: {SurveyingDetailTemplate, EmailCheckAttempt, ScrollCenterDialog},
  props: {
    dialog_flag: Boolean,
    dialog_data: Object,
  },
  data(){
    return {
      // email: undefined,
      attempt_status: undefined,
      attempt_check: undefined,
      attempt_ended: undefined,
      loading: false,
      available: true,
      anonym_status: false,
      rules: {
        required: (value) => !value && value !== ''
      },
      token: null
    }
  },
  watch:{
    // email(){
    //   this.errors.non = [];
    // },
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticate: 'auth/isAuthenticated'
    })
  },
  methods: {
    urlify,
    displayDate:displayDate,
    ...mapActions({
      // checkAttempt: "surveying/CheckAttempt",
      createAttempt: "surveying/createAttempt"
    }),
    continueView(attemptCheck){
      this.attempt_status = attemptCheck.attempt_status
      this.attempt_ended = attemptCheck.attempt_ended
      this.available = attemptCheck.available
      this.attempt_check = attemptCheck
    },
    // checkView() {
    //   this.loading = true;
    //   this.checkAttempt({
    //     survey_id: this.dialog_data.id,
    //     email: this.email !== undefined && this.email !== '' ? this.email: undefined,
    //     token: token,
    //     finalizer: (val) => {
    //       this.attempt_status = val.attempt_status
    //       this.attempt_ended = val.attempt_ended
    //       this.available = val.available
    //       this.attempt_check = val
    //       this.loading = false;
    //     },
    //     catcher:(val) => {
    //       this.loading = false;
    //       this.errors.non = [];
    //       this.available = false
    //       this.mapErrors(val);
    //     }
    //   })
    // },
    openSurveying() {
      this.loading = true;
      this.createAttempt({
        data: {
          survey: this.dialog_data.id,
          user: this.attempt_check.surveying_person,
          created: true,
          ended: false,
          is_anonym: this.anonym_status,
        },
        finalizer: (val) => {
          this.loading = false;
          this.$emit(
            'close',
            {
              survey: this.dialog_data.id,
              attempt: val.id,
              attempt_hash: val.attempt_hash,
              data: val
            }
          )
        }
      })
    },
    continueSurveying(){
      this.$emit(
          'close',
          {
            survey: this.dialog_data.id,
            attempt: this.attempt_check.attempt,
            attempt_hash: this.attempt_check.attempt_hash,
            data: undefined
          }
      )
    },
    closeDialog() {
      this.$emit('close', false)
    },
  },
  // created() {
  //   this.checkView()
  // }
}
</script>

<style scoped>
.mystyle>.v-expansion-panel>.v-expansion-panel-content>>>.v-expansion-panel-content__wrap{
  padding-bottom: 0!important;
}
</style>
